"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDOBToMember = void 0;
const utils_1 = require("@hc-frontend/utils");
/**
 * Create a copy of member and set DOB, age and stringDOB
 *
 * @public
 * @param {T} member - member to update
 * @param {DOB} dob - new DOB
 *
 * @returns {T} - updated member
 *
 * @example
 * ```ts
 * const result = setDOBToMember(member, new Date())
 * ```
 */
function setDOBToMember(member, dob) {
    return {
        ...member,
        dob,
        stringDOB: (0, utils_1.dateToString)(dob),
        age: (0, utils_1.dateToAge)(dob),
    };
}
exports.setDOBToMember = setDOBToMember;
//# sourceMappingURL=set-dob-to-member.js.map